<template>
	<div class="width-100 height-100 flex-centerize">
		<AppLoader v-if="isLoading" />
		<div v-else-if="showErrorMessage">Something went wrong. Please try again later</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { projectHasPermission } from '@/store/modules/projects/getters';
import { hasWorkflowEditPermissions, getWorkflow } from '@/store/modules/workflows/getters';
import { getWorkflowData } from '@/store/modules/workflows/actions';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { ProjectPermissions } from '@ply-io/ply-front-shared-utilities';
export default {
	name: 'ShareWorkflow',
	props: {
		isPostPublishMode: { type: Boolean },
		workflowId: { type: [String, Number] },
	},
	computed: {
		...mapGetters([hasWorkflowEditPermissions.fullPath, projectHasPermission.fullPath, getWorkflow.fullPath]),
		workflow() {
			return this[getWorkflow.fullPath](this.workflowId);
		},
		canShare() {
			return !!this.workflow?.current_version && this.workflow?.is_published && this.hasSharePermissions;
		},
		hasSharePermissions() {
			return (
				this[hasWorkflowEditPermissions.fullPath](this.workflow.id) ||
				this[projectHasPermission.fullPath](this.workflow.project, ProjectPermissions.ChangeWorkflowUsers)
			);
		},
	},
	methods: {
		...mapActions([getWorkflowData.fullPath]),
	},
	async created() {
		try {
			await this[getWorkflowData.fullPath]({ id: this.workflowId });
		} catch {
			this.showErrorMessage = true;
		}
		this.isLoading = false;
		AppDialogManagerService.openShareDialog({
			disableClose: true,
			canShare: this.canShare,
			workflowId: this.workflowId,
			isPostPublishMode: this.isPostPublishMode,
		});
	},
	data() {
		return {
			isLoading: true,
			showErrorMessage: false,
		};
	},
};
</script>
